module.exports = "./static/used-bg.cad8ae5b.png";